/*
 * @Description: 
 * @Autor: wk
 * @Date: 2019-05-18 10:42:34
 * @LastEditors: wk
 * @LastEditTime: 2019-10-14 15:41:08
 */
import Router from '@/routers'
// iframe 下载文件
export function iframeDownload(downUrl, cb) {
  const prefix = process.env.NODE_ENV === 'development' ? '/api' : ''
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = encodeURI(prefix + downUrl)
  document.body.appendChild(iframe)
  setTimeout(
    function () {
      this.remove()
    }.bind(iframe),
    500000
  )
  if (!cb) return // 后端返回json，如{"data":null,"errorCode":-1,"errorMessage":"开始时间和结束时间不能同为空"}    李可政 add                                 
  iframe.onload = function () {
    const iframeWin = iframe.contentWindow // 拿到iframe 的window对象
    if (iframeWin.document.body.innerText.indexOf('errorMessage') !== -1) { // window.document.body.innerText获取页面上的纯文本
      const obj = JSON.parse(iframeWin.document.body.innerText)
      cb(obj.errorMessage || '未知错误')
    }
  }
}


/**
 * 搜索参数更新URL地址
 *
 * @export
 * @returns
 */
export function searchUpdateRoute(query) {
  
  let _query = Object.assign({}, query)
  for (let name in _query) {
    // 清除 值为null|undefined
    if (
      _query[name] === null ||
      _query[name] === undefined ||
      _query[name] === '' ||
      ['pageTotal', 'total'].indexOf(name) !== -1
    ) {
      delete _query[name]
    }
  }
  if (!_query.pageIndex) {
    _query.pageIndex = 1
  }
  if (!_query.pageSize) {
    _query.pageSize = 10
  }
  Router.push({ path: Router.history.current.path, query: _query })
}

// "{1:22}" =》 {1:22} 
export function stringToJson(str) {
  return JSON.parse(str.replace(/(\d+):/g, '"$1":'))
}
// {1:22} =》 "{1:22}" 
export function jsonToString(param) {
  let str = '{'
  for (const k in param) {
    if (param[k] === '') { 
      delete param[k]
    } else {
      str += `${k}:${param[k]},`
    }
  }
  str += '}'
  return str.replace(/(,})/, '}')
}
